import React from 'react';
import Text from 'crehana-ui/Text';

import useCountdown from 'Jsx/Shared/Hooks/useCountdown';

const Timer = ({
  expiredDate,
  label,
  dark,
}: {
  expiredDate: number;
  label: string;
  dark?: boolean;
}) => {
  const { days, hours, minutes, seconds, finished, hasStarted } = useCountdown(
    new Date(expiredDate),
  );

  const textColor = dark ? 'white' : 'red-main';

  if (finished) {
    return null;
  }

  if (expiredDate - new Date().getTime() <= 0) {
    return null;
  }

  return (
    <section
      className="flex items-center"
      style={{
        transition: 'transform 0.2s ease-in-out',
        transform: `scaleY(${hasStarted ? 1 : 0})`,
      }}
    >
      <div className="mr-24">
        <Text type="label" responsive="sm" color={textColor}>
          {label}
        </Text>
      </div>
      {days !== '00' && (
        <div className="flex flex-col mr-24">
          <Text type="subtitle3" responsive="sm" color={textColor}>
            {days}
          </Text>
          <Text type="label" responsive="sm" color={textColor}>
            Dias
          </Text>
        </div>
      )}
      <div className="flex flex-col mr-24">
        <Text type="subtitle3" responsive="sm" color={textColor}>
          {hours}
        </Text>
        <Text type="label" responsive="sm" color={textColor}>
          Hrs
        </Text>
      </div>
      <div className="flex flex-col mr-24">
        <Text type="subtitle3" responsive="sm" color={textColor}>
          {minutes}
        </Text>
        <Text type="label" responsive="sm" color={textColor}>
          min
        </Text>
      </div>
      <div className="flex flex-col mr-24">
        <Text type="subtitle3" responsive="sm" color={textColor}>
          {seconds}
        </Text>
        <Text type="label" responsive="sm" color={textColor}>
          seg
        </Text>
      </div>
    </section>
  );
};

export default Timer;
